
import React from "react";
import { Box, CircularProgress } from "@mui/material";
import CustomText, { textStyles } from "./CustomText";
import CustomButton from "./CustomButton";
import warningicon from "../assets/warningicon.svg";

const UpgradePromptModal = ({ open, loading = false, onConfirm, onClose, message, confirmLabel }) => {
  if (!open) return null; // Don't render anything if closed

  return (
    <Box
      sx={{
        position: "absolute",
    top: 0,
    left: "10px",         // anchors to the outlet’s own area
    right: 0,
    bottom: 0,
    // left: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
     zIndex: 3000,
      }}
    >
      {/* Backdrop (only blurs outlet area) */}
      <Box
        onClick={() => !loading && onClose?.()}
        sx={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(3px)",
          backgroundColor: "rgba(0,0,0,0.25)",
        }}
      />

      {/* Modal Card */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 480,
          mx: "auto",
          bgcolor: "white",
          borderRadius: 3,
          textAlign: "center",
          p: 3,
          zIndex: 2002,
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <img src={warningicon} alt="upgrade" style={{ width: 50, height: 50 }} />
        </Box>

        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "32px",
            color: "#2C384C",
            mb: 2,
          }}
        >
         {message || "To use this feature, kindly upgrade your plan."}
        </CustomText>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}>
          {/* <CustomButton
            onClick={onClose}
            disabled={loading}
            size="medium"
            label="Cancel"
            sx={{
              color: "#172B4D",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "white",
                color: "#172B4D",
              },
            }}
          /> */}

          <CustomButton
            onClick={onConfirm}
            disabled={loading}
            size="medium"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress size={18} thickness={4} sx={{ color: "#fff" }} />
                )}
                {confirmLabel || "Upgrade"}
              </Box>
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UpgradePromptModal;

